
import React from 'react';
import { createRoot } from 'react-dom/client';
 import App from './App';
 import 'bootstrap/dist/css/bootstrap.min.css';
 import 'bootstrap-icons/font/bootstrap-icons.css';
 // **NEW**: Bootstrap JS bundle (includes Collapse, Popper, etc.)
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
 import './styles.css';
 import 'aos/dist/aos.css';        // ① AOS styles


 import AOS from 'aos';           // ② AOS script
AOS.init({ once: true, duration: 800 });




// 1) grab your root container
const container = document.getElementById('root');

// 2) create a root
const root = createRoot(container);

// 3) render your app into it
root.render(
  <React.StrictMode>
   <App />
  </React.StrictMode>
);

